<template>
  <div class="home">
    <div class="buttons">
      <div>
        <router-link
          to="/console/login"
          tag="button"
          class="button login button-200"
          >Login</router-link
        >
      </div>
      <div>
        <router-link
          to="/console/register"
          tag="button"
          class="button register button-200"
          >Register</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {};
</script>
<style>
.buttons {
  width: 480px;
  margin: 0 auto;
}
.buttons div {
  lost-column: 1/2;
}
@media (max-width: 480px) {
  .buttons div {
    lost-column: 1/1;
    text-align: center;
  }
  .buttons {
    width: 100%;
  }
}
</style>
